module.exports = __webpack_public_path__ + "static/img/video_audience.e493d11a.png";